// src/components/POS/payment/OrderSuccessModal.js
import React, { useEffect, useState } from "react";
import { CheckCircle } from "lucide-react";
export default function OrderSuccessModal({ isOpen, onClose, orderNumber }) {
    const [show, setShow] = useState(false);

    // Animate modal appearance
    useEffect(() => {
        if (isOpen) {
            setShow(true); // Start animation
        } else {
            setShow(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
            <div
                className={`rounded-xl w-96 p-6 flex flex-col items-center shadow-2xl bg-white transform transition-all duration-300 ${show ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}
            >
                {/* Success Icon */}
                <CheckCircle size={48} style={{ color: 'var(--color-primary)' }} className="mb-4 animate-bounce" />

                {/* Title */}
                <h3 className="text-xl font-bold mb-2 text-center" style={{ color: 'var(--color-primary)' }}>
                    Order Created!
                </h3>

                {/* Order number and success message */}
                <p className="text-sm mb-6 text-center" style={{ color: 'var(--color-text)', opacity: 0.7 }}>
                    Order <span className="font-semibold">{orderNumber}</span> created successfully.
                </p>

                {/* Close button */}
                <button
                    onClick={onClose}
                    className="font-semibold px-6 py-2 rounded-md text-center transition-colors duration-200 text-white focus:outline-none"
                    style={{ background: 'var(--color-primary)' }}
                    onMouseOver={e => e.currentTarget.style.background = 'var(--color-hover)'}
                    onMouseOut={e => e.currentTarget.style.background = 'var(--color-primary)'}
                >
                    Close
                </button>
            </div>
        </div>
    );
}
